import { has } from "lodash";
import { CampaignComponentVariableCommonImpl } from "../../../campaign-component/variable/model/CampaignComponentVariableCommonImpl";
import { BuiltCampaignComponentSetting } from "./BuiltCampaignComponentSetting";
import _ from "underscore";
const DEFAULT_VARIANT = "default";
export const resolveComponentVariableValue = (targetVariant, defaultVariant, values) => {
    if (targetVariant && has(values, targetVariant)) {
        return {
            variant: targetVariant,
            value: values[targetVariant],
        };
    }
    if (defaultVariant && has(values, defaultVariant)) {
        return {
            variant: defaultVariant,
            value: values[defaultVariant],
        };
    }
    return {
        variant: DEFAULT_VARIANT,
        value: values[DEFAULT_VARIANT],
    };
};
export const isBuiltCampaignComponentVariable = (setting) => {
    return setting instanceof BuiltCampaignComponentVariable;
};
class BuiltCampaignComponentVariable extends BuiltCampaignComponentSetting {
    constructor(variableResponse, context) {
        super(variableResponse, context);
        this.name = variableResponse.name;
        this.display_name = variableResponse.display_name;
        this.description = variableResponse.description;
        this.source = variableResponse.source;
        this.tags = variableResponse.tags;
        this.priority = variableResponse.priority;
        this.values = variableResponse.values;
        this.source_component_id = variableResponse.source_component_id;
        this.context = context;
        this.campaignComponentVariableCommonImpl =
            new CampaignComponentVariableCommonImpl({
                name: this.name,
                display_name: this.display_name,
                tags: this.tags,
                type: this.type,
                values: this.values,
            });
    }
    getDescription() {
        return this.description;
    }
    isInheriting() {
        return this.source_component_id !== this.context.componentId;
    }
    getDimensions() {
        return _.keys(this.values);
    }
    getValue(variant) {
        return this.campaignComponentVariableCommonImpl.getValue(variant);
    }
    hasVariant(variant) {
        return this.campaignComponentVariableCommonImpl.hasVariant(variant);
    }
}
BuiltCampaignComponentVariable.DEFAULT_DIMENSION = "default";
export default BuiltCampaignComponentVariable;
